module.exports = __webpack_public_path__ + "static/media/icon-twitter.421ff609.svg";